<template>
    <div id="report">
        <h3>分析报告</h3>
        <p style="margin:6px auto 20px auto">找到目标数据{{data.length}}条</p>
        <div id="anaresult">
            <ul>
            <li @click="clickLi(item)" v-for="(item,index) in data" :key="index">
                第{{item.row}}行  {{item.gpsTime2}}
            </li>
        </ul>
        </div>
        
    </div>
</template>
<script>
export default {
    props:['data'],
    methods: {
        clickLi(v){
            this.$emit('tr',v)
        }
    },
}
</script>
<style>
    #report{
        padding:10px 20px 10px 20px;
        height: 100%;
    }
    #report>#anaresult>ul li{
        padding:8px 4px;
    }
    #report>#anaresult>ul li:hover{
        cursor: pointer;
        background: #dcebfc;
    }
    #report>#anaresult{
        height: calc(100% - 0px);
        overflow: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/report.vue